var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 7.78L1.22 5l-.947.94L4 9.667l8-8-.94-.94L4 7.78z",
    fill: "#EC2A68"
  })));
};
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTAiIHZpZXdCb3g9IjAgMCAxMiAxMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMuOTk5OTggNy43ODAwMkwxLjIxOTk4IDUuMDAwMDJMMC4yNzMzMTUgNS45NDAwMkwzLjk5OTk4IDkuNjY2NjhMMTIgMS42NjY2OEwxMS4wNiAwLjcyNjY4NUwzLjk5OTk4IDcuNzgwMDJaIiBmaWxsPSIjRUMyQTY4Ii8+Cjwvc3ZnPgo=";
export { SvgCheck as ReactComponent };